import config from '../config'
import http from '../http'

export default{
	//注册印尼用户
	registerByIdonsia:async function(payload) {
		const res = await http({
			url: config.USER_ID_REGISTER,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取邮箱验证码
	getEmailCode:async function(payload) {
		const res = await http({
			url: config.GET_EMAIL_CODE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//邮箱注册
	getRegister:async function(payload) {
		const res = await http({
			url:config.REGISTER,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//修改密码，获取邮箱验证码
	getEmailCode_changepws:async function(payload) {
		const res = await http({
			url: config.GET_EMAIL_CODE_BY_CHANGEPWS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//修改密码
	changePws:async function(payload) {
		const res = await http({
			url: config.CNAGE_PWS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	
}